import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// utils
import { darken } from 'polished'

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 20px;
`

export const DescriptionContainer = styled.div`
  gap: 20px;
  display: flex;
`

export const LevelContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  > div {
   height: 100%;
  }
`

export const LevelLabelsContainer = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`

export const LevelLabelRow = styled.div`
  gap: 12px;
  display: flex;
  align-items: center;
`

export const TrashIconWrapper = styled.div`
  min-width: 260px;
  margin-top: 16px;

  svg {
    align-self: end;
    color: ${colors.red300};

    &:hover {
      path {
        fill: ${darken(0.1, colors.red300)};
      }
    }
  }
`

export const AddButton = styled.div`
  && {
    margin-top: 6px;
    color: ${colors.blue500};
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    width: fit-content;

    &:hover {
      color: ${darken(0.1, colors.blue500)};
    }
  }
`
